import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useUserData } from "../utils/UserData";
import profilePic from "../assets/profilepic.jpg";
import { usePageTitle } from "../utils/usePageTitle";

export default function Home() {
  usePageTitle("Home");
  const [articles, setArticles] = useState([]);
  const data = useUserData();

  useEffect(() => {
    async function loadArticles() {
      try {
        const res = await fetch(`${data.apiToConsume.devTo}&per_page=3`);
        const json = await res.json();
        setArticles(json);
      } catch (err) {
        console.error("Failed to load articles", err);
      }
    }

    loadArticles();
  }, [data.apiToConsume.devTo]);

  return (
    <>
      <section className="relative bg-white text-slate-800 font-sans px-6 py-16 max-w-6xl mx-auto flex flex-col-reverse lg:flex-row items-center justify-between gap-12">
    
        <div className="space-y-6 text-center lg:text-left">

          <p className="text-lg text-slate-600">
            Hello 👋 I'm {data.name}
          </p>

          <h1 className="text-4xl font-bold text-purple-800">
            {data.jobTitle}
          </h1>

          <p className="text-lg text-slate-700 leading-relaxed max-w-xl mx-auto lg:mx-0">
            {data.shortDescription}
          </p>

          <ul className="flex items-center justify-center lg:justify-start gap-2 text-sm text-slate-600">
            <li className="flex items-center gap-1">
              <i className="fa-solid fa-location-dot text-purple-500" />
              <span>{data.basedOn}</span>
            </li>
          </ul>

          <div className="flex flex-wrap justify-center lg:justify-start gap-4 pt-4">
            <Link
              to="/what-i-have-been-building"
              className="bg-purple-700 text-white px-6 py-2 rounded-md hover:bg-purple-800 transition"
            >
              What I've Been Building
            </Link>

            <Link
              to={`mailto:${data.socialMedia.email}`}
              className="border border-purple-700 text-purple-700 px-6 py-2 rounded-md hover:bg-purple-50 transition"
            >
              Contact Me
            </Link>
          </div>

          <div className="flex justify-center lg:justify-start gap-4 pt-4">
            <Link to={data.socialMedia.linkedin} target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-linkedin-in text-xl text-purple-600 hover:text-purple-700" />
            </Link>

            <Link to={data.socialMedia.github} target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-github text-xl text-purple-600 hover:text-purple-700" />
            </Link>

            <Link to={data.socialMedia.devTo} target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-dev text-xl text-purple-600 hover:text-purple-700" />
            </Link>

            <Link to="https://www.npmjs.com/~sarahcssiqueira" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-npm text-xl text-purple-600 hover:text-purple-700"></i>
            </Link>
          </div>
        </div>

        <div className="relative">
          <figure className="inline-block rounded-full p-1 bg-gradient-to-tr from-purple-400 to-purple-700">
            <img
              src={profilePic}
              alt="Sarah Siqueira - Developer Profile"
              className="rounded-full border-4 border-purple-200 shadow-lg max-w-[250px] w-full h-auto transition-transform duration-300 hover:scale-105"
              loading="eager"
            />
          </figure>
        </div>
      </section>

      {/* <section className="max-w-6xl mx-auto px-6 py-16 font-sans text-slate-800">
        <h2 className="text-3xl font-semibold text-center mb-10">
          Featured Projects
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

          <div className="border rounded-lg p-6 hover:shadow-md transition">
            <h3 className="text-xl font-semibold mb-2">
              API RenderFlex
            </h3>
            <p className="text-sm text-slate-600 mb-4">
              WordPress plugin to retrieve and render external API data using reusable templates.
            </p>
            <Link to="/projects" className="text-purple-700 hover:underline">
              Learn more →
            </Link>
          </div>

          <div className="border rounded-lg p-6 hover:shadow-md transition">
            <h3 className="text-xl font-semibold mb-2">
              Pet Tag Generator
            </h3>
            <p className="text-sm text-slate-600 mb-4">
              Ruby on Rails app that generates printable QR-code pet identification tags.
            </p>
            <Link to="/projects" className="text-purple-700 hover:underline">
              Learn more →
            </Link>
          </div>

          <div className="border rounded-lg p-6 hover:shadow-md transition">
            <h3 className="text-xl font-semibold mb-2">
              Zip Page Extractor
            </h3>
            <p className="text-sm text-slate-600 mb-4">
              Python tool that extracts HTML, CSS and JS from webpages and packages them into ZIP archives.
            </p>
            <Link to="/projects" className="text-purple-700 hover:underline">
              Learn more →
            </Link>
          </div>

        </div>
      </section> */}

      <section className="max-w-6xl mx-auto px-6 py-16 font-sans text-slate-800 bg-purple-50">
        <h2 className="text-3xl font-semibold text-center mb-10">
          Latest Posts
        </h2>

        <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <article
              key={article.id}
              className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition"
            >
              <Link to={`../post/${article.slug}/${article.id}`}>
                <img
                  src={article.cover_image}
                  alt={article.title}
                  className="w-full h-48 object-cover"
                />
              </Link>

              <div className="p-4 space-y-2">
                <ul className="flex flex-wrap gap-2 text-sm">
                  {article.tags.split(",").map((tag, i) => (
                    <li
                      key={i}
                      className="bg-purple-100 text-purple-700 px-2 py-0.5 rounded"
                    >
                      #{tag.trim()}
                    </li>
                  ))}
                </ul>

                <Link
                  to={`../post/${article.slug}/${article.id}`}
                  className="block text-base font-semibold hover:text-purple-600 transition"
                >
                  {article.title}
                </Link>

                <ul className="flex gap-4 text-sm text-slate-500">
                  <li>{article.readable_publish_date}</li>
                  <li>{article.reading_time_minutes} min read</li>
                </ul>
              </div>
            </article>
          ))}
        </section>

        <div className="text-center mt-10">
          <Link to="/blog" className="text-purple-700 font-semibold hover:underline">
            View all posts →
          </Link>
        </div>
      </section>

      <section className="h-32 w-full bg-white"></section>
    </>
  );
}